import React, {Fragment, useState, useEffect} from 'react';
import Formulario from "./Components/Formulario";
import Cita from './Components/Cita';

function App() {

  //agregando citas al localstorage

  let citasIniciales  =JSON.parse(localStorage.getItem('citas'));
  if(!citasIniciales){
    citasIniciales = [];
  }

  //arreglo de citas
  const [citas,guardarCitas] = useState(citasIniciales);

  //useEffect para realizar ciertas operaciones cuando cambie algo del state 
  useEffect(() => {
      if (citasIniciales){
        localStorage.setItem('citas',JSON.stringify(citas))
      }else{
        localStorage.setItem('citas',JSON.stringify([]));
      }
  }, [citas, citasIniciales] );


  //funcion que toma las citas actuales y agregue  la nueva
  const crearCita = cita =>{
    guardarCitas([...citas, cita]);
  }

  //funcion  que elimina  una cita por su id
  const eliminarCita = id =>{
    const nuevaCita = citas.filter(cita=> cita.id !== id);
    guardarCitas(nuevaCita);
  }
  //mensaje opcional
  const titulo = citas.length === 0 ?'No hay Citas' : 'Administra tus Citas';

  return (
    <Fragment>
        <h1>Administrador de Pacientes</h1>

        <div className = "container">
          <div className = "row">
            <div className = "one-half column">
              <Formulario crearCita={crearCita}/>
            </div>
            <div className = "one-half column">
                <h2>{titulo}</h2>
                {citas.map(cita =>(
                  <Cita
                    key={cita.id}
                    cita={cita}
                    eliminarCita = {eliminarCita}
                  
                  />
                ))}
            </div>
          </div>
        </div>
    </Fragment>
  
  );
}

export default App;
